// src/pages/VerifyEmail.js
// Lien reçu par email après l'inscription : /verify-email?token=...
import { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { ShieldCheck, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API_URL = 'https://cyberguard-api-ka8f.onrender.com';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { user, checkAuth } = useAuth();
  const [state, setState] = useState('loading'); // loading | ok | error
  const [message, setMessage] = useState('');
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    const token = params.get('token');
    if (!token) {
      setState('error');
      setMessage('Lien incomplet : ouvrez le lien directement depuis l’email reçu.');
      return;
    }
    axios.post(`${API_URL}/api/auth/verify-email`, { token })
      .then(() => { setState('ok'); if (checkAuth) checkAuth(); })
      .catch((err) => {
        setState('error');
        setMessage(err.response?.data?.detail || 'Lien invalide ou expiré.');
      });
  }, [params, checkAuth]);

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center space-y-6">
        <Link to="/" className="inline-flex items-center gap-2">
          <ShieldCheck className="w-10 h-10 text-blue-500" />
          <span className="font-mono text-2xl font-black text-white uppercase tracking-tighter">CyberGuard</span>
        </Link>
        <div className="bg-zinc-900/50 border border-zinc-800 p-8 space-y-4" data-testid="verify-email">
          {state === 'loading' && (
            <p className="text-zinc-400 font-mono text-sm flex items-center justify-center gap-2">
              <Loader2 className="w-4 h-4 animate-spin" /> Vérification en cours…
            </p>
          )}
          {state === 'ok' && (
            <>
              <CheckCircle className="w-10 h-10 text-green-500 mx-auto" />
              <h1 className="text-white font-mono font-bold text-lg uppercase">Adresse confirmée</h1>
              <p className="text-zinc-400 text-sm">Vous pouvez maintenant lancer votre audit gratuit.</p>
              <Link to={user ? '/audits/new' : '/login'} className="inline-block bg-blue-600 hover:bg-blue-700 px-6 py-3 font-mono text-xs uppercase tracking-widest text-white">
                {user ? 'Lancer mon audit' : 'Se connecter'}
              </Link>
            </>
          )}
          {state === 'error' && (
            <>
              <AlertCircle className="w-10 h-10 text-red-500 mx-auto" />
              <h1 className="text-white font-mono font-bold text-lg uppercase">Lien non valide</h1>
              <p className="text-zinc-400 text-sm">{message}</p>
              <p className="text-zinc-500 text-xs">
                Vous pouvez demander un nouveau lien depuis votre tableau de bord (bouton « Renvoyer l'email »).
              </p>
              <Link to={user ? '/dashboard' : '/login'} className="inline-block border border-zinc-700 hover:border-blue-500 px-6 py-3 font-mono text-xs uppercase tracking-widest text-zinc-300">
                {user ? 'Tableau de bord' : 'Se connecter'}
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
